import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('adminToken'));

  useEffect(() => {
    const verifyToken = async () => {
      const savedToken = localStorage.getItem('adminToken');
      if (savedToken) {
        try {
          const res = await authService.getProfile();
          // Ensure we are setting the correct data structure. 
          // If login sets res.data.admin, getProfile usually matches that or returns the object directly.
          // Assuming the previous code `setAdmin(res.data)` was partially correct or the issue was just the error handling.
          setAdmin(res.data);
          setToken(savedToken);
        } catch (err) {
          console.error("Auth verification failed:", err);
          // Only logout on definitive auth errors
          if (err.response && (err.response.status === 401 || err.response.status === 403)) {
            localStorage.removeItem('adminToken');
            setToken(null);
            setAdmin(null);
          }
          // For other errors, we leave the token in localStorage so a refresh might work 
          // if it was a temporary network issue.
        }
      }
      setLoading(false);
    };

    verifyToken();
  }, []);

  const login = async (username, password) => {
    const res = await authService.login(username, password);
    const newToken = res.data.token;
    localStorage.setItem('adminToken', newToken);
    setToken(newToken);
    setAdmin(res.data.admin);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    setToken(null);
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
